module.exports = new __parcel__URL__("shop_machines_shield_battery.02e88fcb.png").toString();